'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = 'M128 384l-128 0 0-384 384 0 0 384-128 0 0 128-128 0 0-128zm0-32l32 0 0 128 64 0 0-128 128 0 0-64-320 0 0 64 96 0zm224-96l0-224-128 0 0 96-32 0 0-96-64 0 0 128-32 0 0-128-64 0 0 224 320 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;